import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Gamepad2 } from 'lucide-react';
import { Button } from '../components/ui/button';

const FruitCrushPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <header className="bg-[#0d6571] shadow-lg">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button
                variant="ghost"
                onClick={() => navigate('/dashboard')}
                className="text-white hover:text-white/80"
              >
                <ArrowLeft className="mr-2" />
                Back to Dashboard
              </Button>
              <div className="h-6 w-px bg-white/30"></div>
              <div className="flex items-center gap-2">
                <Gamepad2 className="w-6 h-6 text-white" />
                <h1 className="text-2xl font-bold text-white">Fruit Crush Game</h1>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Game Container */}
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-7xl bg-white rounded-2xl shadow-2xl overflow-hidden" style={{ height: 'calc(100vh - 120px)' }}>
          {/* Info Bar */}
          <div className="bg-gradient-to-r from-[#0d6571] to-[#0d6571]/80 px-6 py-3 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Gamepad2 className="w-5 h-5 text-white" />
              <span className="text-white font-semibold">Play Fruit Crush</span>
            </div>
            <span className="text-white/80 text-sm">Enjoy the game!</span>
          </div>

          {/* iFrame */}
          <iframe
            src="https://candycrush-4.emergent.host/"
            title="Fruit Crush Game"
            className="w-full"
            style={{ height: 'calc(100% - 52px)', border: 'none' }}
            allow="fullscreen"
          />
        </div>
      </div>
    </div>
  );
};

export default FruitCrushPage;
